import {useEffect, useRef} from 'react';

/**
 * useDidUpdateEffect
 *
 * A custom hook, like useEffect but won't run on mount
 */
export default function useDidUpdateEffect(effect, dependencies) {
  const didMountRef = useRef(false);
  
  useEffect(() => {
    if (didMountRef.current) {
      return effect();
    }
    
    didMountRef.current = true;
    // Because it's a custom hook, we need to pass in the list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
